module.exports = __webpack_public_path__ + "img/zhenjiang.9ec2662.png";